module.exports = "/_next/static/images/blood-4fbd616131dba9a1282edbdc62b12cd4.png";